<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="500px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Make Customer Reward</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="reward"
          method="post"
          :action="url"
          @submitted="$emit('added', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="customer_id" label="Customer Id" />
              </v-col>
              <v-col cols="5">
                <custom-input name="amount_in_euros" type="number" label="Amount (Euro)" />
              </v-col>
              <v-col cols="6" offset="1">
                <custom-input name="fee" type="number" label="Fee (Euro)" />
              </v-col>
            </v-row>
          </v-container>
          <custom-button block color="primary">
            <v-icon>mdi-cash-refund</v-icon>
            Reward Customer
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
  },
  data() {
    return {
      reward: {},
      url: `/api/v1/transactions/customerRewards`,
    };
  },
  methods: {},
};
</script>
